export const Config: Record<string, string> = {
  APPLICATION_ID: '2ee2323f-1cc9-43dc-96ae-5cceae693032',
  CLIENT_TOKEN: 'pubf428644eaca2d6ba116b97495685a6a8',
};
